import "./App.css";
import { useMsal } from "@azure/msal-react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import { forceLogout } from "./config/authConfig";
import { useEffect } from "react";
import AdminPage from "./pages/AdminPage";

function App() {
  const { instance } = useMsal();

  useEffect(() => {
    const logoutAfterTime = () => {
      forceLogout(instance);
    };
    const interval = setInterval(logoutAfterTime, 2700000);
    return () => clearInterval(interval);
  }, [instance]);

  return (
    <Router>
      <AuthenticatedTemplate>
        <div className="container-big">
          <Routes>
            <Route path="/" element={<HomePage />}></Route>
            <Route path="/admin" element={<AdminPage />}></Route>
          </Routes>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </Router>
  );
}

export default App;
